import React from "react";
import { PRIORITY, stageMap } from "../lib/constants";

export function ScoreBadge({ score, priority, size = "md" }) {
  const p = PRIORITY[priority] || PRIORITY.LOW;
  const pad = size === "sm" ? "px-2 py-0.5 text-xs" : "px-2.5 py-1 text-sm";
  return (
    <span
      data-testid="score-badge"
      className={`inline-flex items-center gap-1.5 rounded-md font-semibold ${pad}`}
      style={{ color: p.color, background: p.bg, border: `1px solid ${p.color}40` }}
    >
      <span className="font-heading tabular-nums">{Math.round(score)}</span>
      <span className="opacity-70 text-[0.65rem] uppercase tracking-wide">{priority}</span>
    </span>
  );
}

export function StatusPill({ status }) {
  const s = stageMap[status] || stageMap.NEW;
  return (
    <span
      className="inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium"
      style={{ color: s.color, background: `${s.color}1a`, border: `1px solid ${s.color}40` }}
    >
      <span className="h-1.5 w-1.5 rounded-full" style={{ background: s.color }} />
      {s.label}
    </span>
  );
}
